export default __webpack_public_path__ + "static/media/Background_00224.09fa6626.png";